import * as d3 from 'd3'

export default {
  methods: {
    
    call_LINK(selection, group, filter_) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', 0.5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', () => {
        this.link_Action(group, filter_)
      }) 
    }, 

    link_Action(group, filter_) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: this.chartData.find(f=> f.GROUP == group)[this.keys[d]]}
      })
      let filterString_ = this.filters[filter_] || ''

      console.log(dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },
 
    
  }
}